module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/artillery-strike-toolbar-50.7e51b8f7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/artillery-strike-toolbar-50.png
// module id = 3702
// module chunks = 11